// Pure helpers for the office hours tab (unit tested). The server checks the
// same rules again (Squareme::OfficeHours); these give the team lead an answer
// before saving.

export const DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
export const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri'];
export const MAX_PERIODS = 3;
export const MAX_QUESTIONS = 5;
export const REOPEN_PLACEHOLDER = '{reopen_time}';

// "HH:MM" -> minutes; "24:00" only as a closing time.
export const minutes = (value, closing = false) => {
  const match = /^([01]\d|2[0-4]):([0-5]\d)$/.exec(value || '');
  if (!match) return null;
  const total = Number(match[1]) * 60 + Number(match[2]);
  if (total > 1440 || (total === 1440 && !closing)) return null;
  return total;
};

// [{ key, day }] for everything that would stop the hours being saved.
export const scheduleProblems = hours => {
  const problems = [];
  DAYS.forEach(day => {
    const ranges = (hours.weekly?.[day] || []).map(period => [
      minutes(period.open),
      minutes(period.close, true),
    ]);
    if (
      ranges.some(([from, to]) => from === null || to === null || to <= from)
    ) {
      problems.push({ key: 'ORDER', day });
      return;
    }
    const sorted = [...ranges].sort((a, b) => a[0] - b[0]);
    if (sorted.some((range, i) => i > 0 && range[0] < sorted[i - 1][1]))
      problems.push({ key: 'OVERLAP', day });
  });
  if (hours.enabled && DAYS.every(day => !(hours.weekly?.[day] || []).length))
    problems.push({ key: 'NEEDS_PERIOD', day: '' });
  if ((hours.holidays || []).some(h => h.name && !h.date))
    problems.push({ key: 'HOLIDAY_DATE', day: '' });
  return problems;
};

export const fillReopen = (text, phrase) =>
  String(text || '')
    .split(REOPEN_PLACEHOLDER)
    .join(phrase);

// "Mon 13 Oct, 08:00" in the office time zone.
export const formatOpening = (iso, timeZone) => {
  try {
    return new Intl.DateTimeFormat('en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      timeZone,
    }).format(new Date(iso));
  } catch {
    return iso;
  }
};
